<template>
    <div class="qrcode-display">
      <div class="qrcode-container">
        <img
          :src="paymentUrl"
          alt="支付二维码"
          class="qrcode-canvas"
          @error="handleImageError"
        />
      </div>
  
      <!-- 状态提示 -->
      <div class="status-area">
        <p v-if="status === 'pending'" class="status-text pending">
          <i class="el-icon-loading"></i> 等待扫码支付...
        </p>
        <p v-else-if="status === 'success'" class="status-text success">
          <i class="el-icon-check"></i> 支付成功！
        </p>
        <p v-else-if="status === 'failed'" class="status-text failed">
          <i class="el-icon-close"></i> 支付超时，请重试
        </p>
      </div>
  
      <!-- 操作按钮 -->
      <div class="actions">
        <el-button
          type="primary"
          size="small"
          :loading="refreshLoading"
          @click="handleRefresh"
        >
          刷新二维码
        </el-button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'QRCodeDisplay',
    props: {
      // 二维码图片地址（后端直接返回图片URL）
      paymentUrl: {
        type: String,
        default: '',
      },
      // 支付状态：pending, success, failed
      status: {
        type: String,
        default: 'pending',
      },
    },
    data() {
      return {
        refreshLoading: false,
      }
    },
    watch: {
      // 当支付链接变化时，如果当前是刷新状态，自动关闭 loading
      paymentUrl:(newUrl, oldUrl) =>{
        if (newUrl && this.refreshLoading) {
          this.refreshLoading = false
        }
      },
    },
    methods: {
      // 图片加载失败时的处理
      handleImageError() {
        this.$emit('image-error', '二维码图片加载失败')
      },
  
      // 刷新二维码（通知父组件重新获取新的二维码图片地址）
      handleRefresh() {
        if (this.refreshLoading) return
        this.refreshLoading = true
        this.$emit('refresh')
      },
  
      // 关闭刷新 loading（供父组件调用）
      closeRefreshLoading() {
        this.refreshLoading = false
      },
    }
  }
  </script>
  
  <style scoped>
  .qrcode-display {
    text-align: center;
    padding: 10px;
  }
  
  .qrcode-container {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }
  
  .qrcode-canvas {
    width: 200px;
    height: 200px;
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    object-fit: contain;
    background-color: #fff;
  }
  
  .status-area {
    margin: 15px 0;
    min-height: 40px;
  }
  
  .status-text {
    font-size: 14px;
    margin: 0;
  }
  
  .status-text.pending {
    color: #e6a23c;
  }
  
  .status-text.success {
    color: #67c23a;
  }
  
  .status-text.failed {
    color: #f56c6c;
  }
  
  .actions {
    margin-top: 10px;
    display: flex;
    gap: 10px;
    justify-content: center;
  }
  </style>


// WEBPACK FOOTER //
// src/components/payment.vue